module.exports = __webpack_public_path__ + "static/gallery_west_street_6_thumb-b12fad9357d4ab94fbc9b16b64d7accd.jpg";